import "./headerGeneric.css"
import { FontIcon, getTheme, Icon, Stack } from "@fluentui/react";

const theme = getTheme();

interface IHeaderBase {
  title: String | undefined;
  sizeTitles?: sizeFont;
  subTitle?: String | undefined;
  subTitle2?: String | undefined;
  enabledicon?: boolean;
  iconHeaderName?: String;
}

interface sizeFont {
  first: Number,
  second?: number,
  third?: number,
  iconSize?: number | undefined;
}

const HeaderGeneric = (
  {
    sizeTitles = { first: 20, second: 14, third: 10, iconSize: 38 },
    title = "",
    subTitle = "",
    subTitle2 = "",
    enabledicon = true,
    iconHeaderName = "SliderThumb",
  }: IHeaderBase
) => {
  return (
    <>
      <div className="ms-Grid" dir="ltr">
        <Stack horizontal verticalAlign="end">
          <span hidden={enabledicon}>
            <FontIcon style={{ fontSize: sizeTitles.iconSize, color: "#0078d4" }} iconName={iconHeaderName.toString()} />
          </span>
          <div className="ms-Grid-col ms-sm1 ms-md1 ms-lg12 ">
            <div
              className={`Anim_Fade ms-fontSize-${sizeTitles.first}`}
              style={{
                color: theme.palette.neutralPrimary,
                // paddingLeft: "20px",
              }}
            >
              {title}
            </div>
            <div
              className={`ms-fontSize-${sizeTitles.second}`}
              style={{
                color: theme.palette.neutralSecondaryAlt,
                // paddingLeft: "20px",
              }}
            >
              {subTitle}
            </div>
            <div
              className={`ms-fontSize-${sizeTitles.third}`}
              style={{
                color: theme.palette.neutralSecondaryAlt,
                // paddingLeft: "20px",
              }}
            >
              {subTitle2}
            </div>
          </div>
        </Stack>
      </div>
    </>
  );
};

export default HeaderGeneric;
